import './App.css';
import Tipcal from './components/tipcal/Tipcal';

function App() {
  return (
    <div className="main">
     <Tipcal />
    </div>
  );
}

export default App;
